import { useNavigate } from "react-router-dom";
import "../../styles/LandingHero.css";

const LandingHero = () => {
  const navigate = useNavigate();

  return (
    <section className="landing-hero">
      {/* Image + CTA (grouped for mobile) */}
      <div className="landing-hero-media">
        <div className="landing-hero-bg" />

        <div className="landing-hero-right">
          <button className="circle-btn" onClick={() => navigate("/contactus")}>
            Contact Us
          </button>
        </div>
      </div>

      {/* headline */}
      <div className="text-secondary landing-hero-heading">
        <h1>
          <span className="wise-secondary-gradient highlight-text">
            STAY WISE
          </span>
          , EVERY STEP
          <br />
          FROM CAMPUS TO CORPORATE TO CAREER.
        </h1>
      </div>

      {/* description*/}
      <div className="landing-hero-left">
        <p className="text-secondary landing-hero-description">
          Be part of a vibrant community that <br />
          empowers, connects, and elevates women in the semiconductor ecosystem.
          At WiSE, we’re building pathways from campus to corporate to career —
          <br />
          through mentorship, collaboration, connection and opportunity.
          <br />
          Join us in shaping a more inclusive <br />
          and innovative future.
        </p>
      </div>
    </section>
  );
};

export default LandingHero;
